// @flow
import styled from "styled-components"
import { Text } from "componentsStyled/Typography"
import { mq } from "common/mediaQuery"

export const WarningWrap = styled(Text)`
  color: ${p => p.error 
  ? p.theme.color.red
  : p.theme.color.primaryAccent};

  ${mq.tabletWide} {
    position: absolute;
    right: 4rem;
    top: 4rem;
    text-align: center;
    transform: translateY(-50%);
  }
`;



// WEBPACK FOOTER //
// ./src/components/ReservationList/ReservationTile/Warning/styled.js